/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SharedResourceType } from '../../models/shared-resource-type';
import { ShareLinkDto } from '../../models/share-link-dto';

export interface SharingLinksResourceTypeResourceIdGet$Json$Params {
  resourceType: SharedResourceType;
  resourceId: string;
}

export function sharingLinksResourceTypeResourceIdGet$Json(http: HttpClient, rootUrl: string, params: SharingLinksResourceTypeResourceIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ShareLinkDto>>> {
  const rb = new RequestBuilder(rootUrl, sharingLinksResourceTypeResourceIdGet$Json.PATH, 'get');
  if (params) {
    rb.path('resourceType', params.resourceType, {});
    rb.path('resourceId', params.resourceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ShareLinkDto>>;
    })
  );
}

sharingLinksResourceTypeResourceIdGet$Json.PATH = '/sharing/links/{resourceType}/{resourceId}';
